import { FieldPath } from 'react-hook-form';

import { RHFTextInput } from 'components/input/RHFTextInput';
import { NormalizedLoad } from 'types/Load';

type LoadTextInputProps = React.ComponentPropsWithoutRef<
  typeof RHFTextInput
> & {
  name: FieldPath<NormalizedLoad>;
};
export const LoadTextInput = (props: LoadTextInputProps) => (
  <RHFTextInput {...props} />
);
